// @flow

import * as React from 'react';

import LazyLoad from 'react-lazyload';

import { withTranslation, Link } from '@i18n';
import { useBreakpoint } from '@lib/hooks/useBreakpoint';

import type { Props } from './types';

import {
  StyledCover,
  StyledBannerRightCover,
  StyledImage,
  StyledIcon,
  StyledIconOne,
  StyledIconTwo,
  StyledContentCover,
  StyledMainHeadlineText,
  StyledHeadlineTextSub,
  StyledButtonCover,
  StyledCoverBlock,
  StyledButton,
  StyledButtonSec,
  StyledRightSection,
  StyledRightSectionTop,
  StyledCoverMaxWidthCustom,
  StyledCoverInner,
  StyledIconThree
} from './styles';

const BannerLeft = ({ t, clickEvent }: Props) => {
  const isMobile = useBreakpoint('mobile', 'tablet');

  return (
    <LazyLoad height="100%" offset={800} once>
      <StyledBannerRightCover>
        <StyledCoverMaxWidthCustom>
          <StyledCoverInner>
            <StyledHeadlineTextSub>
              <StyledMainHeadlineText animate>{t('hero.LeftTitleMain')}</StyledMainHeadlineText>
            </StyledHeadlineTextSub>
            <StyledCover>
              <StyledCoverBlock size={{ desktop: 3 / 5 }} xpr={!isMobile}>
                <StyledImage />
              </StyledCoverBlock>
              <StyledCoverBlock size={{ desktop: 2 / 5 }}>
                <StyledRightSection>
                  <StyledRightSectionTop>
                    <StyledContentCover>
                      <StyledCover>
                        <StyledCoverBlock size={{ mobile: 1 / 10 }}>
                          <StyledIcon />
                        </StyledCoverBlock>
                        <StyledCoverBlock pl size={{ mobile: 9 / 10 }}>
                          {t('hero.LeftTitle')}
                        </StyledCoverBlock>
                      </StyledCover>
                    </StyledContentCover>

                    <StyledContentCover>
                      <StyledCover>
                        <StyledCoverBlock size={{ mobile: 1 / 10 }}>
                          <StyledIconOne />
                        </StyledCoverBlock>
                        <StyledCoverBlock pl size={{ mobile: 9 / 10 }}>
                          {t('hero.LeftSubtitle')}
                        </StyledCoverBlock>
                      </StyledCover>
                    </StyledContentCover>

                    <StyledContentCover>
                      <StyledCover>
                        <StyledCoverBlock size={{ mobile: 1 / 10 }}>
                          <StyledIconTwo />
                        </StyledCoverBlock>
                        <StyledCoverBlock pl size={{ mobile: 9 / 10 }}>
                          {t('hero.LeftSubtitleOne')}
                        </StyledCoverBlock>
                      </StyledCover>
                    </StyledContentCover>

                    <StyledContentCover>
                      <StyledCover>
                        <StyledCoverBlock size={{ mobile: 1 / 10 }}>
                          <StyledIconThree />
                        </StyledCoverBlock>
                        <StyledCoverBlock pl size={{ mobile: 9 / 10 }}>
                          {t('hero.LeftSubtitleTwo')}
                        </StyledCoverBlock>
                      </StyledCover>
                    </StyledContentCover>
                  </StyledRightSectionTop>
                  <StyledButtonCover animate>
                    <StyledButtonSec onClick={clickEvent}>{t('hero.Contact')}</StyledButtonSec>
                    <Link href="/how-it-works">
                      <StyledButton>{t('hero.LearnMore')}</StyledButton>
                    </Link>
                  </StyledButtonCover>
                </StyledRightSection>
              </StyledCoverBlock>
            </StyledCover>
          </StyledCoverInner>
        </StyledCoverMaxWidthCustom>
      </StyledBannerRightCover>
    </LazyLoad>
  );
};

export default withTranslation('Home')(BannerLeft);
